/**
 * sends a request to the specified url from a form. this will change the window location.
 * @param path the path to send the post request to
 * @param params the parameters to add to the url
 * @param method the method to use on the form
 * @link https://stackoverflow.com/a/133997/9582435
 */
function sendForm(
  path: string,
  params: { [key: string]: any },
  method = "post"
) {
  // The rest of this code assumes you are not using a library.
  // It can be made less verbose if you use one.
  const form = document.createElement("form");
  form.method = method;
  form.action = path;

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = key;
      hiddenField.value = "" + params[key];

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}

export const RequestUtils = {
  sendForm,
};
